import { erc20Abi } from 'viem'

import { readContract } from '@wagmi/core'

import { config } from '@src/providers/Web3ModalProvider'
import { walletLogger } from '@src/utils/logger'

export const getEvmAllowance = async (
    address: `0x${string}`,
    owner: `0x${string}`,
    spender: `0x${string}`,
    chainId: number
): Promise<bigint> => {
    try {
        const result = await readContract(config, {
            abi: erc20Abi,
            address,
            chainId,
            functionName: 'allowance',
            args: [owner, spender],
        })
        return BigInt(result)
    } catch (error) {
        walletLogger.error('Error checking EVM allowance:', { error })
        return BigInt(0)
    }
}
